var map = {
	"./de": [
		"7/Vu"
	],
	"./de.js": [
		"7/Vu"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Trjk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang lazy ^\.\/.*$
// module id = Trjk
// module chunks = 118